import { Form } from 'antd'

import { useFinancialInsuranceValues } from './FinancialInsuranceContext'
import { FinancialFormValues } from './type'
import {
  formProps,
  normalizeEditOrderData,
  removeFinancialValuesFromStorage
} from './utils'
import { InsurancePaymentControls } from '../InsurancePaymentControls'

type Props = {
  steps: number
  onReadyToSaveData?: () => void
}

export const FinancialInsuranceControls = ({
  steps,
  onReadyToSaveData
}: Props) => {
  const formInstance = Form.useFormInstance()
  const { stepKey } = formProps()
  const { handleCalculate, handleUpdateOrder, isCalculatingLoading, order } =
    useFinancialInsuranceValues()

  const handleGoToCustomer = async (onSuccess: () => void) => {
    await formInstance.validateFields()

    const step = formInstance.getFieldValue(stepKey.name) as number

    handleUpdateOrder({ stage: step + 1, onSuccess, withOrderData: true })
  }

  return (
    <InsurancePaymentControls
      steps={steps}
      onReadyToSaveData={onReadyToSaveData}
      removeFromStorage={() => removeFinancialValuesFromStorage(order?.id)}
      // Stepping back to the quote must not throw the draft order away, or the
      // next calculate would create a second one instead of patching this one.
      keepDraftOrderOnPrevStep
      handleCalculate={handleCalculate}
      isCalculatingLoading={isCalculatingLoading}
      errorUnwrapKeys={['financial']}
      middleStep={{
        onClick: handleGoToCustomer,
        isLoading: isCalculatingLoading
      }}
      normalizeOrderData={(values) => ({
        id: (values as FinancialFormValues).order_id as number,
        requestBody: {
          financial: normalizeEditOrderData(values as FinancialFormValues)
        }
      })}
    />
  )
}
